<script setup lang="ts">
import { ref, watch } from 'vue';
import { history } from 'instantsearch.js/es/lib/routers';
import router from "@/router";

import SearchClaimTable from '@/components/search/SearchClaimTable.vue';
import BaseButton from '@/components/ui/buttons/BaseButton.vue';
import { BoltIcon, UserGroupIcon } from '@heroicons/vue/24/solid';
import CreateClaimGroup from '../components/claim/CreateClaimGroup.vue';
import AlertModal from '@/components/ui/modals/AlertModal.vue';
import adminAPI from '@/services/api';
import { useNotificationStore } from '@/store';
import SelectOffice from '@/components/forms/SelectOffice.vue';
import MountedTeleport from '@/components/MountedTeleport.vue';

// const instantSearch = new InstantSearch('claims', {
//   queryBy: 'passengersEmail,assignedAdminEmail,effectiveFlightIdentifier,effectiveAirlineName,effectiveAirlineIATA,departureAirportIATA,arrivalAirportIATA,ticketNumber',
// });


const claimsPerPage = ref(20);
const showFilters = ref(false);
const routing = {
  router: history()
};

const createGroup = ref(false);
const syncPnrModal = ref({
  open: false,
  gdsPnrId: "",
  officeId: "",
});

function handleClaimClick(newClaimId) {
  router.push({name: 'ClaimOverview', params: {id: newClaimId}});
}

async function syncPnr() {
  const { officeId, gdsPnrId } = syncPnrModal.value;
  if (!officeId || !gdsPnrId) return;

  syncPnrModal.value.open = false;

  const waitNotif = useNotificationStore().emitNotification({
    type: "wait",
    title: "Synchronisation en cours...",
  }, 90000);

  const { success, claimCount } = await adminAPI.syncReservation(officeId, gdsPnrId);
  waitNotif.duration = 0;
  if (success) {
    if (claimCount) useNotificationStore().emitNotification({
      type: "success",
      title: `PNR synchronisé, ${claimCount} claim(s) détectée(s)`,
      message: "Le dossier apparaîtra une fois validé par notre équipe juridique",
    });
    else useNotificationStore().emitNotification({
      title: "PNR synchronisé, aucun vol éligible détecté",
      message: "Si vous pensez qu'il s'agit d'une erreur, merci de nous avertir par email"
    });
  }
}
</script>
<template>
  <AlertModal type="info"
    :open="syncPnrModal.open"
    title="Synchroniser un PNR"
    message="Demander la synchronisation immédiate d'un PNR Amadeus"
    confirm-message="Synchroniser maintenant"
    @close="syncPnrModal.open=false; syncPnrModal.gdsPnrId = ''; syncPnrModal.officeId = ''"
    @confirm="() => syncPnr()"
    @cancel="syncPnrModal.open=false"
  >
    <div class="pb-6">
      <div>
        <label for="name" class="block text-sm font-medium text-gray-700">Numéro de PNR</label>
        <div class="mt-1">
          <input v-model="syncPnrModal.gdsPnrId" class="text-input" required placeholder="Exemple « U3GNCW »" />
        </div>
      </div>
      <div class="mt-4">
        <!-- <label for="name" class="block text-sm font-medium text-gray-700">Office ID</label> -->
        <!-- <div class="mt-1"> -->
          <SelectOffice  v-model="syncPnrModal.officeId"  />
          <!-- <input v-model="syncPnrModal.officeId" class="text-input" required placeholder="Exemple « PARPF3330 »" /> -->
        <!-- </div> -->
      </div>
    </div>
  </AlertModal>

  <div class="px-4 pt-8 sm:px-6 lg:px-12">
    <div class="text-left sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Claims</h1>
        <p class="mt-2 text-sm text-gray-600">Voir et rechercher parmis toutes les claims en cours.</p>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-none">
        <div v-permission="['UPCLAIM_ADMIN']">
          <BaseButton size="md" :text="!createGroup ? 'Créer un groupe' : 'Fermer création de groupe'" :icon="UserGroupIcon" @click="createGroup = !createGroup" />
          <MountedTeleport to="#CreateClaimGroup">
            <CreateClaimGroup v-if="createGroup" />
          </MountedTeleport>
        </div>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-none">
        <BaseButton size="md" text="Synchroniser un PNR" :icon="BoltIcon" @click="syncPnrModal.open = true" />
      </div>
    </div>

    <!-- <BoxFilePreview folder-id="231982233133" />
    <BoxSign /> -->

    <SearchClaimTable @claim-click="handleClaimClick" />

  </div>
</template>

<style>
.ais-SearchBox {
  @apply p-4;
}

.ais-SearchBox-input {
  @apply mt-4;
  width: 100%;
}

.ais-SearchBox-reset {
  display: none;
}
</style>